import React, { useCallback } from 'react';
import Input from 'components/common/Input';
import useSetState from 'customHooks/setState';
import { EventBus } from 'events/EventBus';
import { CanvasEvent } from 'events/EventTypes';
import styles from './index.module.scss';


export const WordGridComponent = ({ object }) => {
  // const [wordGridInfo,setWordGridInfo] = useSetState(object.wordGridInfo ? JSON.parse(object.wordGridInfo) : { src: '', word: '' });
  let wordGridInfo = object.wordGridInfo ? JSON.parse(object.wordGridInfo) : { src: '', word: '' }

  const changeHandler = infoType => e => {
    // setWordGridInfo({ [infoType]: e.target.value });
    wordGridInfo[infoType] = e.target.value;
    EventBus.emit({ event: CanvasEvent.ModifyCanvasObjectPropertyEvent, payload: { object, property: "wordGridInfo", value: JSON.stringify(wordGridInfo) } });
};



  return (
    <>
      <Input className={styles.wordGridInput} label="Src" value={wordGridInfo.src} onChange={changeHandler('src')} />
      <Input className={styles.wordGridInput} label="Word" value={wordGridInfo.word} onChange={changeHandler('word')} />
    </>
  )
};